import { api } from './api';
import type {
  Massage,
  CreateMassageInput,
  UpdateMassageInput,
} from '../types/entities';

export const massagesService = {
  /**
   * Get all massages
   */
  async getAll(): Promise<Massage[]> {
    const response = await api.get<Massage[]>('/api/admin/massages');
    return response.data;
  },

  /**
   * Get massage by ID
   */
  async getById(id: string): Promise<Massage> {
    const response = await api.get<Massage>(`/api/admin/massages/${id}`);
    return response.data;
  },

  /**
   * Create new massage
   */
  async create(data: CreateMassageInput): Promise<Massage> {
    const response = await api.post<Massage>('/api/admin/massages', data);
    return response.data;
  },

  /**
   * Update existing massage
   */
  async update(id: string, data: UpdateMassageInput): Promise<Massage> {
    const response = await api.put<Massage>(`/api/admin/massages/${id}`, data);
    return response.data;
  },

  /**
   * Delete massage
   */
  async delete(id: string): Promise<void> {
    await api.delete(`/api/admin/massages/${id}`);
  },
};
